export default __webpack_public_path__ + "media/images/images/raty/smiley/5-fb11a2e3cd7e76c05fbf7bda1a387c9c.png";